import React from 'react'
import Super from './Super'
import Lic4 from './Lic4.jpeg'
import Lic5 from './Lic5.jpeg'

const Contact=()=> {
  return (
    <div>
      <>
      <section id='contact' className=''>

     
    <div className=' my-3'>
      <div className='row'>
        <div className='col-md-12 my-3'>
          <img src={Lic4} alt=''/>

        </div>

      </div>
      <div className='form'>

      
      <div className='row'>
        <div className='col-md-4'>
          <img id='formimg' className='animated' src={Lic5}  alt=''/>
         
        </div>
        <div className='col-md-8'>
        <form>
  <div className="mb-3">
    <label for="exampleInputEmail1" className="form-label">Name</label>
    <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"/>
    <div id="emailHelp" className="form-text"></div>
  </div>
  <div className="mb-3">
    <label for="exampleInputPassword1" className="form-label">Email</label>
    <input type="password" className="form-control" id="exampleInputPassword1"/>
  </div>
  <div className="mb-3">
    <label for="exampleInputPassword1" className="form-label">Phone</label>
    <input type="password" className="form-control" id="exampleInputPassword1"/>
  </div>
  <div className="mb-3">
    <label for="exampleInputPassword1" className="form-label">Sybject</label>
    <input type="password" className="form-control" id="exampleInputPassword1"/>
  </div>
  <div className="mb-3">
    <label for="exampleInputPassword1" className="form-label">Message</label>
    <input type="password" className="form-control" id="exampleInputPassword1"/>
  </div>
  <div className="mb-3 form-check">
    <input type="checkbox" className="form-check-input" id="exampleCheck1"/>
    <label className="form-check-label" for="exampleCheck1">Check me out</label>
  </div>
  <button type="submit" className="btn btn-primary">Submit</button>
</form>
</div>

        </div>

      </div>

      
    </div>
    </section>
    <Super/>
    </>
      
    </div>
  )
}

export default Contact
